import {
  AbgComponentStyleRoot,
  AbgStyleParts,
  AbgSxProps,
  WithComponentParts,
} from '@abg/typings/styling';

import {
  ProfileManagementFormParts,
  ProfileManagementPartsProperties,
} from '../../organisms/ProfileManagement/profile-management.types';

export interface DriverLicense {
  driverLicenseIssuer?: string | undefined;
  driverLicenseNumber?: string | undefined;
  dob?: string | undefined;
  driverLicenseState?: string | undefined;
}

export interface PrecheckDriverLicense {
  issuer: string | undefined;
  number: string | undefined;
  dateOfBirth: string | undefined;
  state?: string | undefined;
}

export enum DriverLicenseFormLayout {
  STATE_IN_LAST = 'state-in-last',
  STATE_NEXT_TO_ISSUER = 'state-next-to-issuer',
}

export interface DriverLicenseProperties
  extends WithComponentParts<
    ProfileManagementFormParts,
    ProfileManagementPartsProperties
  > {
  layout?: DriverLicenseFormLayout;
  defaultValues?: DriverLicense | undefined;
  isMaskedLicenseNumber?: boolean;
  isFormDisabled?: boolean;
}

export interface DriverLicensePrecheckProperties
  extends WithComponentParts<
    ProfileManagementFormParts,
    ProfileManagementPartsProperties
  > {
  defaultValues?: PrecheckDriverLicense | undefined;
  dateFormat: string;
  styleParts: DriverLicenseStyleParts | undefined;
  isMaskedLicenseNumber?: boolean;
  isFormDisabled?: boolean;
  layout?: DriverLicenseFormLayout;
}

export type DriverLicenseStyleParts = AbgComponentStyleRoot &
  AbgStyleParts<{
    container: AbgSxProps;
  }>;

export interface State {
  isoCountryCode: string;
  stateCode: string;
  stateName: string;
}
export interface Country {
  isoCountryCode: string;
  isoCountryName: string;
  countryName: string;
  internationalDivisionCode: string | null;
  states: State[];
}

export interface CountryInformationResponse {
  countries: Country[];
  states: State[];
}

export interface DriverLicenseFormType {
  driverLicenseIssuer?: string | undefined;
  driverLicenseNumber?: string | undefined;
  dob?: string | undefined;
  driverLicenseState?: string | undefined;
}
